import React from "react";
import PropTypes from "prop-types";
import { Global, css } from "@emotion/react";

const GlobalStyles = ({ isProductPage = false }) => (
    <Global
        styles={(theme) => css`
            /* CSS Reset */
            html,
            body,
            div,
            span,
            applet,
            object,
            iframe,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p,
            blockquote,
            pre,
            a,
            abbr,
            acronym,
            address,
            big,
            cite,
            code,
            del,
            dfn,
            em,
            img,
            ins,
            kbd,
            q,
            s,
            samp,
            small,
            strike,
            strong,
            sub,
            sup,
            tt,
            var,
            b,
            u,
            i,
            center,
            dl,
            dt,
            dd,
            ol,
            ul,
            li,
            fieldset,
            form,
            label,
            legend,
            table,
            caption,
            tbody,
            tfoot,
            thead,
            tr,
            th,
            td,
            article,
            aside,
            canvas,
            details,
            embed,
            figure,
            figcaption,
            footer,
            header,
            hgroup,
            menu,
            nav,
            output,
            ruby,
            section,
            summary,
            time,
            mark,
            audio,
            video {
                margin: 0;
                padding: 0;
                border: 0;
                font-size: 100%;
                font: inherit;
                vertical-align: baseline;
            }
            main,
            article,
            aside,
            details,
            figcaption,
            figure,
            footer,
            header,
            hgroup,
            menu,
            nav,
            section {
                display: block;
            }
            body {
                line-height: 1;
            }
            ol,
            ul {
                list-style: none;
            }
            blockquote,
            q {
                quotes: none;
            }
            blockquote:before,
            blockquote:after,
            q:before,
            q:after {
                content: "";
                content: none;
            }
            table {
                border-collapse: collapse;
                border-spacing: 0;
            }

            /* Base Styles */
            *,
            *::after,
            *::before {
                box-sizing: border-box;
                font-size: inherit;
                font-weight: inherit;
                font-family: inherit;
            }

            *:focus {
                outline: 3px solid transparent;
                outline-offset: 5px;
                background-color: transparent;
            }

            *:focus-visible {
                outline: 3px solid ${theme.palette.focusBlue};
                outline-offset: 5px;
            }

            @supports not selector(:focus-visible) {
                *:focus {
                    outline: 3px solid ${theme.palette.focusBlue};
                }
            }

            html {
                font-size: 10px;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                scrollbar-gutter: stable;
            }

            body {
                font-family: ${theme.fontFamily.primary};
                font-weight: 400;
                font-size: 2rem;
                line-height: 1.6;
            }

            html,
            body,
            #___gatsby,
            #gatsby-focus-wrapper {
                min-height: 100vh;
            }

            .inline-gatsby-image-wrapper {
                max-width: 100%;
            }

            picture.object-fit-polyfill {
                position: static !important;
            }

            a {
                text-decoration: none;
                color: ${theme.palette.teal};
            }

            p {
                margin-bottom: ${theme.layout.paragraphSpacing};

                &:empty {
                    display: none;
                }
            }

            strong,
            b {
                font-weight: 700;
            }

            em {
                font-style: italic;
            }

            button {
                border: 0;
                background-color: transparent;
                border-radius: 0;
                padding: 0;
                cursor: pointer;
            }

            sup {
                font-size: 0.45em;
                vertical-align: super;
            }

            sub {
                font-size: 0.85em;
                vertical-align: ${isProductPage ? `-2px` : `sub`};
            }

            img,
            iframe {
                max-width: 100%;
            }

            img {
                height: auto;
            }

            .grecaptcha-badge {
                visibility: hidden;
            }
        `}
    />
);

GlobalStyles.propTypes = {
    isProductPage: PropTypes.bool,
};

export default GlobalStyles;
